import {useContext} from 'react'

import PropTypes from 'prop-types'

import {atomButtonDesigns} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeNotification, {moleculeNotificationAutoClose} from '@s-ui/react-molecule-notification'

import {NOTIFICATIONS, NOTIFICATIONS_PROPS} from './config.js'

export const Notification = ({onClose, onClickButton, type = NOTIFICATIONS.EMPTY}) => {
  const {i18n} = useContext(Context)

  const NOTIFICATIONS_LITERALS = {
    [NOTIFICATIONS.SUCCESS]: i18n.t('COMMON.FAVORITE_DEALER_ADDED_NOTIFICATION_SUCCESS'),
    [NOTIFICATIONS.SUCCESS_DELETE]: i18n.t('COMMON.FAVORITE_DEALER_DELETED_NOTIFICATION_SUCCESS'),
    [NOTIFICATIONS.ERROR]: i18n.t('COMMON.FAVORITE_DEALER_ADDED_NOTIFICATION_ERROR'),
    [NOTIFICATIONS.ERROR_DELETE]: i18n.t('COMMON.FAVORITE_DEALER_DELETED_NOTIFICATION_ERROR')
  }

  const buttons = [
    {
      negative: true,
      design: atomButtonDesigns.LINK,
      children: i18n.t('COMMON.FAVORITE_DEALER_ADDED_NOTIFICATION_SUCCESS_CTA'),
      onClick: onClickButton
    }
  ]
  const buttonsProps = type === NOTIFICATIONS.SUCCESS ? {buttons} : {}

  return (
    <MoleculeNotification
      autoClose={moleculeNotificationAutoClose.long}
      onClose={onClose}
      {...buttonsProps}
      {...NOTIFICATIONS_PROPS[type]}
    >
      {NOTIFICATIONS_LITERALS[type]}
    </MoleculeNotification>
  )
}

Notification.propTypes = {
  onClose: PropTypes.func,
  onClickButton: PropTypes.func,
  type: PropTypes.oneOf([
    NOTIFICATIONS.EMPTY,
    NOTIFICATIONS.ERROR,
    NOTIFICATIONS.ERROR_DELETE,
    NOTIFICATIONS.SUCCESS,
    NOTIFICATIONS.SUCCESS_DELETE
  ])
}
